import { components } from '@kurtosys/ksys-app-components';

import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent.js';

const RedirectButton = components.base.RedirectButton.RedirectButton;

export default InjectedStyledComponent(RedirectButton, 'results', ['continueButton']);
